<template>
	<Modal v-if="display" @hideModal="toggleModal" :small="true">
		<div class="p-5">

			<h1 class="font-bold text-lg text-left mt-0">
				Easy Monthly Payments (billed per month)
			</h1>
			<div>
				<ul>
					<li>Pay per month</li>
					<li>Consistent monthly amount</li>
					<li>Predictable, worry-free payment</li>
				</ul>
			</div>
	
			<div>
				<p> With Spring Green's Easy Monthly Payments, you will pay equal monthly installments throughout the year.
					This option allows for consistent montly budget planning. No need to worry about paying after service
					invoices, just provide your credit card and there is one less bill to remember to pay.</p>
	
				<p> No matter when you sign up for Easy Monthly Payments, we'll spread the balance evenly over the remaining
					months of the calendar year. If you begin in January, your annual service amout will be spread across 12
					monthly payments. If you begin in May, your balance will be divided equally over 8 monthly payments. At
					the start of the following year, your rate will be redistributed across 12 monthly payments.</p>
			</div>
		</div>
	</Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import Modal from '~/components/Modal.vue';

const display = ref(false);

const toggleModal = () => {
	display.value = !display.value;
};

function show() {
  display.value = true;
}

function closeModal() {
  display.value = false;
}

defineExpose({
  show,
  closeModal
});

</script>
